export const isSuccess = (res) => {
    return res && res.code === 0;
};

export const isNoData = (res) => {
    return res && res.code === 97;
};
